import React from 'react';
import { WithIcon } from './WithIcon';

export const IconChevronRight = WithIcon(
  'Chevron Right',
  '0 0 407.436 407.436',
  <polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718" />
);
